export const productDataList = [
  {
    productName: "beatXP Marv Neo 1.85'' HD Display with Bluetooth Calling Smartwatch",
    price: {
      mrp: 6999,
      cost: 4049,
      discountPercent: 42,
    },
  },
  {
    productName: 'NOVA NHP 8106 Hair Dryer  (1400 W, Black)',
    price: {
      mrp: 1899,
      cost: 1124,
      discountPercent: 40,
    },
  },
  {
    productName: 'Longway Speedy 300 mm Energy Saving 3 Blade Table Fan  (Black, Pack of 1)',
    price: {
      mrp: 2250,
      cost: 1199,
      discountPercent: 46,
    },
  },
  {
    productName: 'boAt Rockerz 255 Pro+ /258 Pro+ with ASAP Charge and upto 60 Hours Playback Bluetooth Headset  (Active Black, In the Ear)',
    price: {
      mrp: 2990,
      cost: 1199,
      discountPercent: 59,
    },
    subcategory: 'Headphones',
    productImage: 'https://rukminim2.flixcart.com/image/416/416/l31x2fk0/headphone/a/s/h/-original-image9ehehz8amg2.jpeg?q=70',
    category: 'Electronics',
    description: 'boAt Rockerz 255 Pro+ is a power-packed in-ear wireless neckband headphone that has been ergonomically designed to meet the needs of music lovers. The headphones come equipped with Bluetooth V5.0 for instant wireless connectivity. Its super powerful 300mAh battery provides a humongous playtime of up to 60 hours for an extended audio bliss. Its 10mm dynamic drivers help supply superior musical experience to the user with immersive sound. With our ASAP fast charge technology, you can get the headphones fully charged in just 60 minutes. It also offers resistance against water and sweat with IPX7 rated premium build. One can control the playback and calls easily via the provided multifunction controls and even summon respective smart Voice Assistant. Get ready to get enthralled by the pumped up audio and soaring vibe of Rockerz 255 Pro+',
    tagline: 'Grab Now!',
    quantity: 1,
    seller: "652ebf61b409f906d81645a3",
  },
  {
    productName: "SAMSUNG Galaxy F13 (Sunrise Copper, 64 GB)  (4 GB RAM)",
    price: {
      mrp: 14999,
      cost: 9199,
      discountPercent: 38,
    },
  },
  {
    productName: "APPLE iPhone 13 (Midnight, 128 GB)",
    price: {
      mrp: 19999,
      cost: 14199,
      discountPercent: 30,
    },
  },
];

export const bannerData = [
  { _id: 1, url: 'https://static.vecteezy.com/system/resources/previews/011/871/820/non_2x/online-shopping-on-phone-buy-sell-business-digital-web-banner-application-money-advertising-payment-ecommerce-illustration-search-vector.jpg' },
  { _id: 2, url: 'https://rukminim1.flixcart.com/flap/3376/560/image/a5320d3f852657e8.jpg?q=50' },
  { _id: 3, url: 'https://rukminim1.flixcart.com/flap/3376/560/image/5df65ad101e18dbf.jpg?q=50' },
  { _id: 4, url: 'https://rukminim1.flixcart.com/flap/3376/560/image/8a89ee09acc1a9e5.jpg?q=50' },
];
